import { render, staticRenderFns } from "./expander.vue?vue&type=template&id=34021732"
import script from "./expander.vue?vue&type=script&lang=js"
export * from "./expander.vue?vue&type=script&lang=js"
import style0 from "./expander.less?vue&type=style&index=0&prod&lang=less&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports